import { QueryClient } from 'react-query';

export const AppQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
});
